import { getImageSizes } from '@ag1/ui';
import clsx from 'clsx';
import Image, { StaticImageData } from 'next/image';
import styles from './ProductImage.module.scss';

interface ProductImageProps {
  src: string | StaticImageData;
  alt: string;
  quantity?: number;
  hideQuantityBadge?: boolean;
  className?: string;
  imageClassName?: string;
}

export const ProductImage = ({
  src,
  alt,
  quantity,
  hideQuantityBadge = false,
  className,
  imageClassName
}: ProductImageProps) => {
  const sizes = getImageSizes({ xxs: '64px', s: '100px' });

  return (
    <div className={clsx(styles.wrapper, className)}>
      <div className={clsx(styles.imageContainer, imageClassName)}>
        <Image
          src={src || '/placeholder-image.jpg'}
          alt={alt || 'Product image'}
          width={800}
          height={800}
          sizes={sizes}
        />
      </div>
      {!hideQuantityBadge && typeof quantity === 'number' && (
        <div className={styles.badge} data-testid="product-quantity">
          {quantity}
        </div>
      )}
    </div>
  );
};
